import { useAppHeaderObserver } from 'hooks/useAppLayoutObservers'
import { memo, useRef } from 'react'
import NavBarGlobalBar from './NavBarGlobalBar'
import NavBarTertiaryBar from './NavBarTertiaryBar'
import NavBarUtilBar from './NavBarUtilBar'
import styled from 'styled-components'

const NavBarContainer = styled.div`
  position: relative;
  border-bottom: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};

  @media print {
    display: none;
  }
`

function NavBar() {
  const ref = useRef<HTMLDivElement>(null)
  useAppHeaderObserver(ref, 'static')

  return <NavBarContainer ref={ref} data-testid="navbar">
    <NavBarTertiaryBar />
    <NavBarUtilBar />
    <NavBarGlobalBar />
  </NavBarContainer>
}

export default memo(NavBar)
